import { MSG_ERRO_SERVIDOR } from "../../../shared/constantes/mensagens";

const INITIAL_STATE = {
  alerta: {},
  listaOP: [],
  esperandoSolicitacao: false,
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_ORGAO_PAGADOR_INICIAR':
      return { ...state, esperandoSolicitacao: true, alerta: {} }
    case 'REQUERIMENTO_ORGAO_PAGADOR_BUSCAR_SUCESSO':
      return { ...state, listaOP: action.payload, esperandoSolicitacao: false }
    case 'REQUERIMENTO_ORGAO_PAGADOR_BUSCAR_ERRO':
      return { ...state, esperandoSolicitacao: false, alerta: { title: 'Erro: ', 
        message: typeof action.payload == "string" ? action.payload : MSG_ERRO_SERVIDOR, severity: 'error' }}
    default:
      return { ...state }  
  }
}
